import { Component, OnInit, ViewEncapsulation, ChangeDetectionStrategy, OnDestroy, Input, input } from '@angular/core';
import { Store } from '@ngrx/store';
import { interval, Observable, race, Subject } from 'rxjs';
import * as fromNotifications from '../../store/index';
import { Notification, NotificationType } from '../../store/index';
import { filter, map, skipWhile, takeUntil } from 'rxjs/operators';
import * as fromAuth from 'src/app/modules/authentication/store/auth/auth.selectors';
import { AppHeaderTheme } from '@app/core/layout/app-header/app-header-theme.model';
@Component({
  selector: 'topo-notification-header-button',
  templateUrl: './notification-header-button.component.html',
  styleUrls: ['../../../../core/layout/app-header/components/app-header-button.scss', './notification-header-button.component.scss'],
  // encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NotificationHeaderButtonComponent implements OnInit, OnDestroy {
  theme = input<AppHeaderTheme>(AppHeaderTheme.Default);
  index: number = 1;
  hoverNotifications$: Observable<Notification[]>;
  unreadNotifications$: Observable<Notification[]>;
  bellBuffer = null;
  audioContext = new AudioContext();
  destroy$ = new Subject<void>();

  notificationsVisible = this.store.selectSignal(fromNotifications.selectShowNotifications);
  notificationsLoading = this.store.selectSignal(fromNotifications.selectNotificationsLoading);

  constructor(private store: Store<any>) {}

  ngOnInit(): void {
    this.hoverNotifications$ = this.store.select(fromNotifications.selectHoverNotifications);
    this.unreadNotifications$ = this.store.select(fromNotifications.selectUnreadNotifications);

    this.store.dispatch(fromNotifications.loadUnreadNotifications({ params: null }));

    race(
      interval(300000).pipe(
        skipWhile(() => {
          const isLoading = this.notificationsLoading();
          return isLoading;
        })
      ),
      this.store.select(fromAuth.selectPermissionsChangeTime).pipe(filter(time => !!time))
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.store.dispatch(fromNotifications.loadUnreadNotifications({ params: null }));
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  showNotificationsClick(): void {
    const notificationsVisible = this.notificationsVisible();
    this.store.dispatch(!notificationsVisible ? fromNotifications.showNotifications() : fromNotifications.hideNotifications());
  }
}
